<! --
/**
* SuiteCRM is a customer relationship management program developed by SuiteCRM Ltd.
* Copyright (C) 2021 SuiteCRM Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SUITECRM, SUITECRM DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->
<ng-container *ngIf="hoverEnabled()">
    <ng-container *ngTemplateOutlet="menuItem"></ng-container>
</ng-container>
<ng-container *ngIf="!hoverEnabled()">
    <ng-container *ngTemplateOutlet="menuItem"></ng-container>
</ng-container>

<ng-template #menuItem>
    <div class="menu-item-wrapper" #menuItemWrapper>
        <span data-target=".navbar-collapse" data-toggle="collapse" #topLink
              (touchstart)="onTouchStart()"
              (touchend)="onTouchEnd()"
              (click)="onClick($event)"
        >
                <scrm-menu-item-link [class]="{
                                            'top-nav-link': true,
                                            'nav-link-nongrouped': true,
                                            'dropdown-toggle': item.submenu.length,
                                            'hover-enabled': hoverEnabled(),
                                            'nav-link-activated': showDropdown()
                                        }"
                                     [link]="item.link"
                                     [config]="this.topLinkConfig">
                </scrm-menu-item-link>
        </span>

        <div (click)="hideDropdown()"
             aria-labelledby="navbarDropdownMenuLink"
             *ngIf="item.submenu.length"
             class="dropdown-menu submenu"
             [class.show]="showDropdown()"
             [class.hover-enabled]="hoverEnabled()">

            <div *ngFor="let sub of item.submenu" class="nav-item">

                <scrm-menu-item-link
                        [class]="'sub-nav-link nav-link action-link'"
                        [icon]="sub.icon"
                        [link]="sub.link">
                </scrm-menu-item-link>

            </div>

            <ng-container *ngIf="item && item.module">
                <scrm-sub-menu-recently-viewed
                        [module]="item.module"
                        [config]="recentlyViewedConfig"
                        (click)="$event.stopPropagation();">

                </scrm-sub-menu-recently-viewed>
                <scrm-sub-menu-favorites
                        [module]="item.module"
                        [config]="favoritesConfig"
                        (click)="$event.stopPropagation()"></scrm-sub-menu-favorites>
            </ng-container>
        </div>
    </div>
</ng-template>
